import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchBar({
  //#region Props
  value,
  onChange,
  placeholder = "Search",
  fullWidth = true,
  variant = "outlined",
  size = "medium",
  sx = {},
  onKeyDown,
  ...props
  //#endregion
}) {
  //#region Render
  return (
    <TextField
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      fullWidth={fullWidth}
      variant={variant}
      size={size}
      onKeyDown={onKeyDown}
      sx={sx} 
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
  //#endregion
}
